<script lang="ts" setup>
import { computed } from "vue";
import type { MListProps } from "./MList.props";
import { mListDefaults } from "./MList.props";

const props = withDefaults(defineProps<MListProps>(), mListDefaults);

const classes = computed(() => [
  "m-list",
  props.dense && "m-list--dense",
  props.separator && "m-list--separator",
  props.bordered && "m-list--bordered",
]);
</script>

<template>
  <ul :class="classes">
    <slot />
  </ul>
</template>

<style lang="scss">
.m-list {
  margin-block-start: 0;
  margin-block-end: 0;
  padding-inline: 0;

  // Ports Quasar q-list modifiers — see ENG-20660. Target direct children so
  // it works whether rows are <q-item> (pre ENG-20662) or <m-list-item>.
  &--bordered {
    border: 1px solid rgba(0, 0, 0, 0.12);
  }

  &--dense > * {
    min-height: 32px;
    padding: 2px 16px;
  }

  &--separator > * + * {
    border-top: 1px solid rgba(0, 0, 0, 0.12);
  }
}
</style>
